export type MfaEnrollmentFlowType = 'signup' | 'activate' | 'passkey';

export interface MfaEnrollmentFlowConfig {
  message: string;
  hideEmailEnrollment?: boolean;
  hideSMSEnrollment?: boolean;
  hidePasskeyEnrollment?: boolean;
}

export const MFA_ENROLLMENT_FLOW_CONFIG: Record<MfaEnrollmentFlowType, MfaEnrollmentFlowConfig> = {
  signup: {
    message: 'Your email is verified',
  },
  passkey: {
    message: 'A passkey has been created',
    hidePasskeyEnrollment: true,
  },
  activate: {
    message: 'Your details are confirmed',
  },
};
